import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import FastOCRImport from './FastOCRImport';
import { Zap } from 'lucide-react';

/**
 * Dialog wrapper for FastOCRImport component
 */
export default function FastOCRImportDialog({ 
  open, 
  onOpenChange, 
  onSuccess,
  existingInspectionId = null
}) {
  const navigate = useNavigate();
  
  const handleInspectionCreated = (inspectionId, inspection) => {
    if (onSuccess) {
      onSuccess(inspectionId);
    }
    if (inspectionId) {
      navigate(`/inspections/${inspectionId}`);
    }
    onOpenChange(false);
  };
  
  const handleDataExtracted = (data) => {
    // Data extracted but not yet used to create inspection
    // This is handled by the FastOCRImport component internally
    console.log('Data extracted:', Object.keys(data).length, 'fields');
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Zap className="h-5 w-5 text-purple-600" />
            Fast OCR Import
          </DialogTitle>
          <DialogDescription>
            Quickly populate inspection fields from photos, scanned documents, or PDFs.
            Upload your files and let AI extract the data for you.
          </DialogDescription>
        </DialogHeader>
        
        <FastOCRImport
          onDataExtracted={handleDataExtracted}
          onInspectionCreated={handleInspectionCreated}
          existingInspectionId={existingInspectionId}
        />
      </DialogContent>
    </Dialog>
  );
}
